import {User} from '../../../shared/models/app-user';

export class Element {
    name: string;
    type?: string;
    title?: string;
    titleLocation?: string;
    cellType?: string;
    inputType?: string;
    isRequired?: boolean;
    defaultValue?: any;
    columns?: Element[];
    choices?: any[];
    value?: string;
    min?: string;
    max?: string;
    visibleIf?: string;
}

export class Page {
    name: string;
    title?: string;
    elements?: Element[];
    visibleIf?: string;
}

export class Survey {
    pages: Page[];
}

export class ConfigElement {
    name: string;
    value?: any;
}

export class ConfigNanoGrid {
    user: User;
    [name: string]: ConfigElement[] | User;
}
